import React, { Component } from 'react';
import { Page } from 'components/page-container';
import { PageHeader } from 'components/page-header';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { TabComponent } from 'components/sub-navigation/components/TabComponent';
import { Export } from './export'
import { Import } from './import'
interface IInvoiceState {
    currentSelected: number
}
export class _Invoices extends Component<RouteComponentProps, IInvoiceState>{
    public state = {
        currentSelected: 1    
    };
    public componentDidMount(){
        this.setCurrTab()
    }
    public componentDidUpdate(props:any,state:any){
        if(this.props.location !== props.location){
            this.setCurrTab()
        }
    }
    public setCurrTab = (selectedId?: number) => {
        let thisUrl = this.props.location.pathname;
        thisUrl = thisUrl.replace('/exception-management/charge-download','')
        let id = selectedId? selectedId: 1;
        if(!selectedId){
            switch(thisUrl){
                case '/export':
                    id=1
                break;
                case '/import':
                    id=2
                break;
            }
        }
        this.setState({
            currentSelected: id
        })
    }
    
    public render() {
        return (
            <React.Fragment>
                <PageHeader id="customerBilling-search">Charge Download Logs</PageHeader>
                <Page>
                    <TabComponent className="padding-top-xLarge" name="customerBilling-search"
                    navLinks={[
                        {
                            id: 1,
                            title: 'Export',
                            emptyLabel: ''
                        },
                        {
                            id: 2,
                            title: 'Import',
                            emptyLabel: ''
                        }
                    ]} callbackFc={(e:number) => {
                        const importExport = e === 1? 'export': 'import'
                        this.props.history.push(`/exception-management/charge-download/${importExport}`);
                        this.setState({currentSelected: e})}
                     }
                     activeTab={this.state.currentSelected-1} />
                    {this.state.currentSelected === 1 && <Export />}
                    {this.state.currentSelected === 2 && <Import />}
                </Page>
            </React.Fragment>
        );
    }
   
}
export const Index = withRouter(_Invoices);
